import type {ReactElement, ReactNode} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Text, TextSize} from '@Components/text';
import {resolveChatMediaUrl} from '@Libraries/ai-chat.library';
import {MediaItemSizeType} from '@Libraries/s3-library';
import styles from './fields.module.scss';

export interface OptionCardProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  leadingSlot?: ReactNode;
  imageUrl?: string;
}

export function OptionCard({label, isSelected, onClick, leadingSlot, imageUrl}: OptionCardProps): ReactElement {
  const cardClass = isSelected ? `${styles.optionCard} ${styles.optionCardSelected}` : styles.optionCard;

  const renderThumb = (): ReactElement | null => {
    if (imageUrl === undefined || imageUrl === '') {
      return null;
    }
    return <img className={styles.optionThumb} src={resolveChatMediaUrl(imageUrl, MediaItemSizeType.THUMB)} alt={label} />;
  };

  return (
    <ClickableDiv className={cardClass} onClick={onClick}>
      {leadingSlot}
      {renderThumb()}
      <Text size={TextSize.XSMALL} val={label} bold={isSelected} />
    </ClickableDiv>
  );
}
